import React from "react";
import ReactDOM from "react-dom/client";
import RoutesPosgrados from "./hooks/routesPosgrados";
import RoutesCarreras from "./hooks/routesCarreras";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import NewHome from "./pages/newHome";
import Oferta from "./pages/Oferta";
import Floating from "./components/Floating";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Rendicion from "./pages/Rendicion";
import Contacto from "./pages/Contacto";
import ModeloDistancia from "./pages/ModeloDistancia";
import Modalidadenlinea from "./newPages/oferta/Modalidadenlinea";
import PresencialNew from "./newPages/oferta/Presencial";
import ModeloPresencial from "./pages/ModeloPresencial";

import Herramientas from "./pages/Herramientas";
import NewFormacionPermanente from "./newPages/oferta/FormacionPermanente";
import NewEnlinea from "./newPages/oferta/Enlinea";
import Decidesermas from "../src/newPages/DecideSerMas";
import Imagen from "./pages/Imagen";
import Alumni from "./pages/Alumni";
import "./index.css";
import ParqueCientifico from "./pages/ParqueCientifico";
import Calidad from "./newPages/Calidad";
import PruebaAdmision from "./pages/PruebaAdmision";
import Reingreso from "./newPages/alumnos/Reingreso";
import Competencias from "./newPages/alumnos/Competencias";
import SegundaLenguaa from "./newPages/alumnos/SegundaLengua";
import NewMatriculas from "./newPages/Matriculas";
import Newtitulo from "./newPages/alumnos/TituloValidable";

import NewGober from "./newPages/Gobernanza";

import NewTec from "./newPages/oferta/Tecnologias";
import NewTrasparencia from "./newPages/Transparencia";
import Internacional from "./newPages/alumnos/Internacional";

import MisionSemanaSanta from "./newPages/alumnos/MisionSemanaSanta";
import AcercadePlan from "./newPages/AcercadePlan";
import FernandoRielo from "./newPages/FernandoRielo";
import AlianzaUPV from "./newPages/alumnos/AlianzaUPV";
import Edes from "./newPages/oferta/Edes";
import MIA from "./newPages/alumnos/MIA";
import Posgrados from "./newPages/oferta/Posgrados";
import ScrollToHash from "./components/ScrollToHash";
import Gem from "./newPages/Gem";
import ImpactoSocial from "./newPages/notas/ImpactoSocial";
import GestionProcesos from "./newPages/GestionProcesos";
import ConsultoriosJuridicos from "./newPages/ConsultoriosJuridicos";
import UtplSostenible from "./newPages/UtplSostenible";
import RoutesTec from "./hooks/routesTec";
import PageContacto from "./pages/PageContacto";
import ConsultoriosPsicologia from "./newPages/ConsultoriosPsicologia";
import Especializaciones from "./newPages/notas/Especializaciones";
import TecEstrategica from "./newPages/notas/TecEstrategica";
import CarismaIdente from "./newPages/CarismaIdente";
import RelacionesInterinstitucionales from "./newPages/RelacionesInterinstitucionales";
import HomologacionExterna from "./newPages/servicios/HomologacionExterna";
import SegundaTitulacion from "./newPages/servicios/SegundaTitulacion";
import ValidacionTrayectoria from "./newPages/servicios/ValidacionTrayectoria";
import Ejemplo from "./newPages/servicios/Ejemplo";
import HomologacionInterna from "./newPages/servicios/HomologacionInterna";
import SistemaAcademico from "./newPages/homenew/SistemaAcademico";
import Incorporaciones from "./newPages/homenew/Incorporaciones";
import NewRoutes from "./hooks/NewRoutes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/">
        <ScrollToHash></ScrollToHash>
        <Floating></Floating>
        <Header></Header>
        <Routes>
          <Route index element={<NewHome></NewHome>} />
          <Route path="/oferta" element={<Oferta />} />
     
          <Route
            path="/temp-relaciones-interinstitucionales"
            element={<RelacionesInterinstitucionales />}
          />

          <Route path="/alumni" element={<Alumni />} />
          <Route path="/imagen" element={<Imagen />} />
          <Route path="/rendicioncuentas" element={<Rendicion />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/gem" element={<Gem />} />

          <Route path="/presencial" element={<PresencialNew />} />
          <Route path="/estudiar-en-loja" element={<ModeloPresencial />} />

          <Route path="/en-linea" element={<NewEnlinea />} />

          <Route path="/estudiar-en-linea" element={<Modalidadenlinea />} />
          <Route path="/herramientas" element={<Herramientas />} />
          <Route
            path="/formacion-permanente"
            element={<NewFormacionPermanente />}
          />
          <Route path="/parque-cientifico" element={<ParqueCientifico />} />
          <Route path="/calidad" element={<Calidad />} />
          <Route path="/informe-gem" element={<Gem />} />
          <Route path="/presencial/prueba" element={<PruebaAdmision />} />
          <Route path="/retoma-tus-estudios" element={<Reingreso />} />
          <Route path="/competencias" element={<Competencias />} />
          <Route
            path="/segunda-lengua"
            element={<SegundaLenguaa></SegundaLenguaa>}
          />
          <Route path="/matriculas" element={<NewMatriculas></NewMatriculas>} />
          <Route path="/validacion-titulo" element={<Newtitulo></Newtitulo>} />
          <Route path="/gobernanza" element={<NewGober></NewGober>} />
          <Route path="/acercade" element={<AcercadePlan></AcercadePlan>} />
          <Route path="/tecnologias" element={<NewTec></NewTec>} />

          <Route
            path="/transparencia"
            element={<NewTrasparencia></NewTrasparencia>}
          />
          <Route
            path="/internacional"
            element={<Internacional></Internacional>}
          />
          <Route
            path="/mision-semana-santa"
            element={<MisionSemanaSanta></MisionSemanaSanta>}
          />
          <Route
            path="/carisma-idente"
            element={<CarismaIdente></CarismaIdente>}
          />
          <Route
            path="/fernando-rielo"
            element={<FernandoRielo></FernandoRielo>}
          />

          <Route path="/alianza-upv" element={<AlianzaUPV></AlianzaUPV>} />

          <Route path="/acompanamiento-integral" element={<MIA></MIA>} />
          <Route
            path="/reconocidos-en-impacto-social"
            element={<ImpactoSocial></ImpactoSocial>}
          />
          <Route
            path="/especializate-en-imagenologia-anestesiologia"
            element={<Especializaciones></Especializaciones>}
          />
          <Route
            path="/transforma-la-comunicacion-institucional"
            element={<TecEstrategica></TecEstrategica>}
          />

          <Route
            path="/efectos-consumo-tabaco"
            element={<TecEstrategica></TecEstrategica>}
          />
          <Route
            path="/gestion-procesos"
            element={<GestionProcesos></GestionProcesos>}
          />
          <Route
            path="/servicios-juridicos"
            element={<ConsultoriosJuridicos></ConsultoriosJuridicos>}
          />
          <Route
            path="/consultorios-psicologia"
            element={<ConsultoriosPsicologia></ConsultoriosPsicologia>}
          />
          <Route
            path="/utpl-sostenible"
            element={<UtplSostenible></UtplSostenible>}
          />
          <Route
            path="/contacto-social"
            element={<PageContacto></PageContacto>}
          />

          <Route
            path="/homologacion-externa"
            element={<HomologacionExterna></HomologacionExterna>}
          />
          <Route
            path="/homologacion-interna"
            element={<HomologacionInterna></HomologacionInterna>}
          />
          <Route
            path="/segunda-titulacion"
            element={<SegundaTitulacion></SegundaTitulacion>}
          />
          <Route
            path="/validacion-trayectoria"
            element={<ValidacionTrayectoria></ValidacionTrayectoria>}
          />
          <Route
            path="/sistema-academico"
            element={<SistemaAcademico></SistemaAcademico>}
          />
          <Route
            path="/incorporaciones"
            element={<Incorporaciones></Incorporaciones>}
          />
        </Routes>

        <RoutesPosgrados></RoutesPosgrados>
        <RoutesCarreras></RoutesCarreras>
        <RoutesTec></RoutesTec>

        <NewRoutes></NewRoutes>
        {/* <ApolloProvider client={client}>
        <RoutesPosgrados></RoutesPosgrados>
      </ApolloProvider> */}
        <Footer></Footer>
      </BrowserRouter>{" "}
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
